import React from 'react';

import Admin from 'hive-admin';

import Types from '../../../modules/types';

import backgroundFields from './background';
import maskFields from './mask';
import shadowFields from './shadow';
import borderFields from './border';
import borderRadiusFields from './borderRadius';
import zoomFields from './zoom';
import parallaxFields from './parallax';
import blendModeFields from './blendMode';
import transformFields from './transform';
import filterFields from './filter';
import colorFields from './color';
import letterSpacingFields from './letterSpacing';
import whiteSpaceFields from './whiteSpace';
import transitionFields from './transition';
import revealFields from './reveal';
import linkFields from './link';

import {
  AddSegmentButton,
  AfterAddButtonWrapper,
} from '../items/index';

const {
  CONTENT_BUILDER_EFFECT: {
    node: NODE_TYPE,
    TYPE_ITEMS: ITEMS,
    TYPE_LABELS_MAP: LABELS_MAP,
  },
} = Types;

const FIELDS = [
  ...[
    'type',
    'hide',
  ].map(name => Admin.compileFromLibrary(['FieldHidden', {
    name,
    label: null,
  }])),
  ...backgroundFields,
  ...maskFields,
  ...shadowFields,
  ...borderFields,
  ...borderRadiusFields,
  ...zoomFields,
  ...parallaxFields,
  ...blendModeFields,
  ...transformFields,
  ...filterFields,
  ...colorFields,
  ...letterSpacingFields,
  ...whiteSpaceFields,
  ...transitionFields,
  ...revealFields,
  ...linkFields,
];

const ICONS_MAP = {};

[
  [
    'FieldContentBuilderEffectsFrame',
    ITEMS.filter(item => item.realms.includes('FRAME')),
  ],
  [
    'FieldContentBuilderEffectsText',
    ITEMS.filter(item => item.realms.includes('TEXT')),
  ],
].forEach(([name, items]) => {
  const CONFIG = {
    fields: FIELDS,
    // addButtonChoices: items,
    // addButtonLabel: 'Add Effect',
    renderAddButton: () => null,
    renderAfterAddButton: (props, field) => (
      <AfterAddButtonWrapper>
        <AddSegmentButton
          key={name}
          label="Add Effect"
          items={items}
          onAddItem={item => field.addItem(
            field.props.generateNewItem(field.props, field, item.id)
          )}
          props={props}
        />
      </AfterAddButtonWrapper>
    ),
    pasteButtonLabel: 'Paste Effect',
    toolbarProps: {
      // eslint-disable-next-line no-unused-vars
      getSupportsMediaQueries: type => true,
      items,
      itemsLabelsMap: LABELS_MAP,
      itemsIconsMap: ICONS_MAP,
    },
    copyRealm: 'ContentBuilder:Effect',
    pasteRealm: `ContentBuilder:Effect:(${
      items
      .map(item => item.type)
      .join('|')
    })`,
    nodeType: NODE_TYPE,
  };
  Admin.addToLibrary(
    name,
    ({
      toolbarProps = {},
      ...config
    } = {}) => {
      const result = Admin.compileFromLibrary(['FieldContentBuilderNodes', {
        ...CONFIG,
        ...config,
        toolbarProps: {
          ...CONFIG.toolbarProps,
          ...toolbarProps,
        },
      }]);
      result[Admin.LIBRARY_NAME_KEY] = name;
      return result;
    },
  );
});
